import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import store from '../store'


Vue.use(VueRouter)

// middleware

// const ifAuthenticated = (to, from, next) => {
//   if (store.getters.isCredentialsLoaded) {
//     next()
//     return
//   }
//   next('/login')
// }

// const ifNotAuthenticated = (to, from, next) => {
//   if (!store.getters.isCredentialsLoaded) {
//     next()
//     return
//   }
//   next('/')
// }

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
    // beforeEnter: ifAuthenticated
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
    // beforeEnter: ifNotAuthenticated
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('../views/ForgotPwd.vue')
  },
  {
    path: '/reset-password/:forgotToken',
    name: 'Reset password',
    component: () => import('../views/ResetPwd.vue')
  },
  {
    path: '/interventions',
    name: 'Interventions',
    component: () => import('../views/Interventions.vue')
  },
  {
    path: '/operations',
    name: 'Operations',
    component: () => import('../views/Operations.vue')
  },
  {
    path: '/operations/new',
    name: 'OperationsNew',
    component: () => import('../views/OperationsNew.vue')
  },
  {
    path: '/operations/edit/:id',
    name: 'OperationsEdit',
    component: () => import('../views/OperationsNew.vue'),
    props: { editing: true }
  },
  {
    path: '/operations/open/:id',
    name: 'OperationsOpen',
    component: () => import('../views/OperationsNew.vue'),
    props: { opening: true }
  },
  {
    path: '/action-collaborative',
    name: 'ActionCollaborative',
    component: () => import('../views/ActionCollaborative.vue')
  },
  {
    path: '/action-collaborative/reponses/:id',
    name: 'ActionCollaborativeAnswers',
    component: () => import('../views/ActionCollaborativeReponses.vue')
  },
  {
    path: '/action-collaborative/new',
    name: 'ActionCollaborativeNew',
    component: () => import('../views/ActionCollaborativeNew.vue')
  },
  {
    path: '/action-collaborative/edit/:id',
    name: 'ActionCollaborativeEdit',
    component: () => import('../views/ActionCollaborativeNew.vue'),
    props: { editing: true }
  },
  {
    path: '/action-collaborative/open/:id',
    name: 'ActionCollaborativeOpen',
    component: () => import('../views/ActionCollaborativeNew.vue'),
    props: { opening: true }
  },
  {
    path: '/enquetes',
    name: 'Enquetes',
    component: () => import('../views/Enquetes.vue')
  },
  {
    path: '/enquetes/new',
    name: 'EnquetesNew',
    component: () => import('../views/EnquetesNew.vue')
  },
  {
    path: '/enquetes/edit/:id',
    name: 'EnquetesEdit',
    component: () => import('../views/EnquetesNew.vue'),
    props: { editing: true }
  },
  {
    path: '/enquetes/open/:id',
    name: 'EnquetesOpen',
    component: () => import('../views/EnquetesNew.vue'),
    props: { opening: true }
  },
  {
    path: '/enquetes/resultat/detail',
    name: 'EnquetesResultatDetail',
    component: () => import('../views/EnquetesResultatDetail.vue')
  },
  {
    path: '/enquetes/resultat',
    name: 'EnquetesResultat',
    component: () => import('../views/EnquetesResultat.vue')
  },
  {
    path: '/locataires',
    name: 'Locataires',
    component: () => import('../views/Locataires.vue')
  },
  {
    path: '/gestion-points/loterie',
    name: 'GestionPointsLoterie',
    component: () => import('../views/GestionPointsLoterie.vue')
  },
  {
    path: '/gestion-points/loterie/new',
    name: 'GestionPointsLoterieNew',
    component: () => import('../views/GestionPointsLoterieNew.vue')
  },
  {
    path: '/gestion-points/loterie/edit/:id',
    name: 'GestionPointsLoterieEdit',
    component: () => import('../views/GestionPointsLoterieNew.vue'),
    props: { editing: true }
  },
  {
    path: '/gestion-points/loterie/open/:id',
    name: 'GestionPointsLoterieOpen',
    component: () => import('../views/GestionPointsLoterieNew.vue'),
    props: { opening: true }
  },
  {
    path: '/gestion-points/catalogue',
    name: 'GestionPointsCatalogue',
    component: () => import('../views/GestionPointsCatalogue.vue')
  },
  {
    path: '/gestion-points/catalogue/new',
    name: 'GestionPointsCatalogueNew',
    component: () => import('../views/GestionPointsCatalogueNew.vue')
  },
  {
    path: '/gestion-points/catalogue/edit/:id',
    name: 'GestionPointsCatalogueEdit',
    component: () => import('../views/GestionPointsCatalogueNew.vue'),
    props: { editing: true }
  },
  {
    path: '/gestion-points/catalogue/open/:id',
    name: 'GestionPointsCatalogueOpen',
    component: () => import('../views/GestionPointsCatalogueNew.vue'),
    props: { opening: true }
  },
  {
    path: '/comptes',
    name: 'Comptes',
    component: () => import('../views/Comptes.vue')
  },
  {
    path: '/comptes/new',
    name: 'ComptesNew',
    component: () => import('../views/ComptesNew.vue')
  },
  {
    path: '/annuaire',
    name: 'Annuaire',
    component: () => import('../views/Annuaire.vue')
  },
  {
    path: '/annonces',
    name: 'Annonces',
    component: () => import('../views/Annonces.vue')
  },
  {
    path: '/baux',
    name: 'Baux',
    component: () => import('../views/Baux.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
